import { Component, EventEmitter, Input, Output } from "@angular/core";
import { StateManagementService } from "../../../providers/state-management/state-management.service";

@Component({
  selector: "numeric-tool",
  templateUrl: "numeric-tool.html",
})
export class NumericToolComponent {
  @Output() onValueUpdate: EventEmitter<any> = new EventEmitter();
  @Input() readonly: boolean = false;
  value: number = null;
  description: string = "None";
  label: string = "numericToolDesc";

  constructor(public stateData: StateManagementService) {
    if (this.existingData) {
      this.value = this.existingData["values"]["numeric"];
    }
  }

  onFocus() {
    setTimeout(() => {
      if (this.value === null) {
        this.value = 0;
        this.onValueUpdate.emit({
          severity: this.value,
          values: {
            numeric: this.value,
          },
        });
      }
    }, 250);
  }

  valueChanged(value: number) {
    // console.log( "Value changed: ", value );
    this.value = value;
    this.stateData.setMyData(this.value);
    if (value === 0) {
      this.description = "None";
    } else if (value < 4) {
      this.description = "Mild";
    } else if (value < 7) {
      this.description = "Moderate";
    } else {
      this.description = "Severe";
    }
    this.onValueUpdate.emit({
      severity: value,
      values: {
        numeric: value,
      },
    });
  }

  @Input() set existingData(data: object) {
    // console.log( "Setting new NUMERIC form value: ", data );
    if (data && data["tool"] === "numeric" && data["values"]) {
      this.value = data["values"]["numeric"];
    }
    // console.log( "New NUMERIC form value: ", this.value );
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/numeric-tool/numeric-tool.ts